export const UsersResource = {
  name: "Users",
  path: "/user-management/users",
  access: ["read-users"],
};
